import styles from "./App.module.css";

import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import React, { Suspense, lazy } from "react";

import CircularProgress from "@mui/material/CircularProgress";

const Home = lazy(() => import("./containers/Home/Home"));
const DashBoard = lazy(() =>
  import("./containers/DashBoardBody/DashBoardBody")
);
const Manage = lazy(() => import("./containers/ManageBody/ManageBody"));
const Map = lazy(() => import("./containers/MapBody/MapBody"));
const Info = lazy(() => import("./containers/InfoBody/InfoBody"));
const Nodes = lazy(() => import("./containers/NodesBody/NodesBody"));
const Users = lazy(() => import("./containers/UsersBody/UsersBody"));
const Feedback = lazy(() => import("./containers/FeedbackBody/FeedbackBody"));
const Profile = lazy(() => import("./components/Profile/Profile"));

const AccountSetting = lazy(() =>
  import("./components/AccountSetting/AccountSetting")
);
const Notification = lazy(() =>
  import("./components/Notification/Notification")
);
const SettingsSideBar = lazy(() =>
  import("./components/SettingsSideBar/SettingsSideBar")
);
const AdminSideBar = lazy(() =>
  import("./components/AdminSideBar/AdminSideBar")
);
const SideBar = lazy(() => import("./components/SideBar/SideBar"));
const TopBar = lazy(() => import("./components/TopBar/TopBar"));

function App() {
  // const { path } = useRouteMatch();

  return (
    <div>
      <Suspense
        fallback={
          <div className={styles.spinner}>
            <CircularProgress color="secondary" />
          </div>
        }
      >
        <Switch>
          <Route path="/Home">
            <Home />
          </Route>
          <Route path="/DashBoard">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <SideBar />
              <DashBoard />
            </div>
          </Route>
          <Route path="/Manage">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <SideBar />
              <Manage />
            </div>
          </Route>
          <Route path="/Map">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <SideBar />
              <Map />
            </div>
          </Route>
          <Route path="/Info">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <SideBar />
              <Info />
            </div>
          </Route>
          <Route path="/AdminDashboard">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <AdminSideBar />
              <DashBoard />
            </div>
          </Route>
          <Route path="/AdminManage">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <AdminSideBar />
              <Manage />
            </div>
          </Route>
          <Route path="/AdminMap">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <AdminSideBar />
              <Map />
            </div>
          </Route>
          <Route path="/Nodes">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <AdminSideBar />
              <Nodes />
            </div>
          </Route>
          <Route path="/Users">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <AdminSideBar />
              <Users />
            </div>
          </Route>
          <Route path="/Feedback">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.container}>
              <AdminSideBar />
              <Feedback />
            </div>
          </Route>

          <Route path="/profile">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.SettingsBodyContainer}>
              <div className={styles.left}>
                <SettingsSideBar />
              </div>
              <div className={styles.right}>
                <Profile />
              </div>
            </div>
          </Route>

          <Route path="/accountSetting">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.SettingsBodyContainer}>
              <div className={styles.left}>
                <SettingsSideBar />
              </div>
              <div className={styles.right}>
                <AccountSetting />
              </div>
            </div>
          </Route>

          <Route path="/notification">
            <div style={{ zIndex: 1000, position: "sticky", top: 0, left: 0 }}>
              <TopBar />
            </div>
            <div className={styles.SettingsBodyContainer}>
              <div className={styles.left}>
                <SettingsSideBar />
              </div>
              <div className={styles.right}>
                <Notification />
              </div>
            </div>
          </Route>

          <Route path="*">
            <Redirect to="/Home">
              <Home />
            </Redirect>
          </Route>
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
